import {Action} from '@ngrx/store';
import {DocumentIdentifierType, JobType, UserTaxGroup} from 'src/app/spartacus/spartacus-custom.module';

export const LOAD_DOCUMENT_IDENTIFIER_TYPES = '[User] Load Document Identifier Types';
export const LOAD_DOCUMENT_IDENTIFIER_TYPES_FAIL = '[User] Load Document Identifier Types Fail';
export const LOAD_DOCUMENT_IDENTIFIER_TYPES_SUCCESS = '[User] Load Document Identifier Types Success';

export const LOAD_JOB_TYPES = '[User] Load Job Types';
export const LOAD_JOB_TYPES_FAIL = '[User] Load Job Types Fail';
export const LOAD_JOB_TYPES_SUCCESS = '[User] Load Job Types Success';


export const LOAD_USER_TAX_GROUPS = '[User] Load User Tax Groups';
export const LOAD_USER_TAX_GROUPS_FAIL = '[User] Load User Tax Groups Fail';
export const LOAD_USER_TAX_GROUPS_SUCCESS = '[User] Load User Tax Groups Success';

export class LoadDocumentIdentifierTypes implements Action {
  readonly type = LOAD_DOCUMENT_IDENTIFIER_TYPES;

  constructor() {
  }
}

export class LoadDocumentIdentifierTypesFail implements Action {
  readonly type = LOAD_DOCUMENT_IDENTIFIER_TYPES_FAIL;

  constructor(public payload: any) {
  }
}

export class LoadDocumentIdentifierTypesSuccess implements Action {
  readonly type = LOAD_DOCUMENT_IDENTIFIER_TYPES_SUCCESS;

  constructor(public payload: DocumentIdentifierType[]) {
  }
}

export class LoadJobTypes implements Action {
  readonly type = LOAD_JOB_TYPES;

  constructor() {
  }
}

export class LoadJobTypesFail implements Action {
  readonly type = LOAD_JOB_TYPES_FAIL;

  constructor(public payload: any) {
  }
}

export class LoadJobTypesSuccess implements Action {
  readonly type = LOAD_JOB_TYPES_SUCCESS;

  constructor(public payload: JobType[]) {
  }
}

export class LoadUserTaxGroups implements Action {
  readonly type = LOAD_USER_TAX_GROUPS;

  constructor() {
  }
}

export class LoadUserTaxGroupsFail implements Action {
  readonly type = LOAD_USER_TAX_GROUPS_FAIL;

  constructor(public payload: any) {
  }
}

export class LoadUserTaxGroupsSuccess implements Action {
  readonly type = LOAD_USER_TAX_GROUPS_SUCCESS;

  constructor(public payload: UserTaxGroup[]) {
  }
}

export type CustomUserTypesAction =
  LoadDocumentIdentifierTypes
  | LoadDocumentIdentifierTypesFail
  | LoadDocumentIdentifierTypesSuccess
  | LoadJobTypes
  | LoadJobTypesFail
  | LoadUserTaxGroups
  | LoadUserTaxGroupsFail
  | LoadUserTaxGroupsSuccess
  | LoadJobTypesSuccess;

